// Deep-links into collapsible-content rows. When the URL hash matches a row's
// anchor id (e.g. /pages/faq#reheat-instructions), the row is opened and
// scrolled into view. Non-collapsible anchors are left to native behavior.
(function () {
  if (window.__collapsibleAnchorInit) return;
  window.__collapsibleAnchorInit = true;

  function openFromHash() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;

    var target;
    try {
      target = document.querySelector(hash);
    } catch (e) {
      return;
    }
    if (!target) return;

    // Only manage collapsible rows; leave other anchors to native behavior.
    var details = target.matches('details') ? target : target.querySelector('details');
    if (!details) return;

    details.open = true;
    var top = target.getBoundingClientRect().top + window.pageYOffset - 100;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  window.addEventListener('DOMContentLoaded', openFromHash);
  window.addEventListener('hashchange', openFromHash);
  if (document.readyState !== 'loading') openFromHash();
})();
